import { ExternalAccesoGuard } from './../../../core/guards/deactivate/external-acceso.guard';
import { RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';
import { AccesoProveedorComponent } from './pages/acceso-proveedor/acceso-proveedor.component';
import { HomeProveedorComponent } from './pages/home-proveedor/home-proveedor.component';
import { ProveedorComponent } from './proveedor.component';

const PROVEEDOR_ROUTE: Routes = [{
  path: '',
  component: ProveedorComponent,
  children: [
    {
      path: '',
      pathMatch: 'full',
      redirectTo: 'acces'
    }
    ,
    {
      path: 'acces',
      component: AccesoProveedorComponent,
      canActivate: [ExternalAccesoGuard],
      data: {
        authorities: [],
        pageTitle: 'PROVEEDOR.title'
      }
    }
    ,
    {
      path: 'home',
      component: HomeProveedorComponent,
      data: {
        authorities: [],
        pageTitle: 'PROVEEDOR.title'
      }
    }
  ]
}];

@NgModule({
  imports: [RouterModule.forChild(PROVEEDOR_ROUTE)],
  exports: [RouterModule]
})
export class ProveedorRoutingModule { }
